import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cadastrar-prestacao-contas',
  templateUrl: './cadastrar-prestacao-contas.component.html',
  styleUrls: ['./cadastrar-prestacao-contas.component.css']
})
export class CadastrarPrestacaoContasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
